<template>
  <div class='CardFunil'>
    <div class='label'>{{ label }}</div>
    <div class='corpo'>
      <div class='barra' :style='{ height: porcentagem + "%" }'></div>
      <div class='conteudo'>
        <div class='sessoes'>{{ sessoes }}</div>
        <div class='porcentagem'>{{ formatar(porcentagem) }}%</div>
        <template v-if='variacao !== null'>
          <div class='variacao' :class='tendencia'>
            {{ formatar(variacao) }}%
            <span class='seta'></span>
          </div>
          <div class='comparacao'>vs. Ontem</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardFunil',
  props: {
    label: { type: String, required: true },
    sessoes: { type: Number, required: true },
    porcentagem: { type: Number, required: true },
    variacao: { type: Number, default: null }
  },
  computed: {
    tendencia () {
      return this.variacao < 0 ? 'queda' : 'alta'
    }
  },
  methods: {
    formatar (numero) {
      return numero.toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.CardFunil {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #e5e5e5;
}
.CardFunil:first-child {
  border-left: none;
}
.label {
  min-height: 40px;
  padding: 0 8px;
  font-size: 13px;
  text-align: center;
  color: #303030;
}
.corpo {
  position: relative;
  flex: 1;
  min-height: 150px;
}
.barra {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f1f1fb;
}
.conteudo {
  position: relative;
  padding-top: 8px;
  text-align: center;
}
.sessoes {
  font-size: 13px;
  color: #8a8a8a;
}
.porcentagem {
  margin-top: 30px;
  font-size: 18px;
  color: #303030;
}
.variacao {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 11px;
}
.alta { color: #1a8f4c; }
.queda { color: #d72c46; }
.seta {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.alta .seta { border-bottom: 7px solid currentColor; }
.queda .seta { border-top: 7px solid currentColor; }
.comparacao {
  font-size: 11px;
  color: #303030;
}
</style>
